// src/pages/Home.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { colors } from '../styles/colors';

const Home = () => {
  const [characters, setCharacters] = useState([]);
  const [games, setGames] = useState([]);
  const [worlds, setWorlds] = useState([]);
  const [enemies, setEnemies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const { data: charData } = await supabase.from('characters').select('*').order('id').limit(4);
        const { data: gamesData } = await supabase.from('games').select('*').order('id').limit(4);
        const { data: worldsData } = await supabase.from('worlds').select('*').order('id').limit(4);
        const { data: enemiesData } = await supabase.from('enemies').select('*').order('id').limit(4);

        setCharacters(charData || []);
        setGames(gamesData || []);
        setWorlds(worldsData || []);
        setEnemies(enemiesData || []);
      } catch (err) {
        console.error('Error fetching data:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, []);

  if (loading) return <p style={{ textAlign: 'center', marginTop: '2rem' }}>Loading...</p>;

  const renderCard = (item, type) => {
    let icon = '';
    let extra = null;
    switch (type) {
      case 'Characters':
        icon = '🍄';
        extra = (
          <>
            <p style={{ margin: 0, fontWeight: '500' }}>{item.species}</p>
            <p style={{ marginTop: '4px', fontSize: '0.9rem', color: colors.textLight }}>
              First appearance: {item.first_appearance || 'Unknown'}
            </p>
          </>
        );
        break;
      case 'Games':
        icon = '🎮';
        extra = <p style={{ margin: 0, fontWeight: '500', color: colors.textLight }}>{item.year || ''}</p>;
        break;
      case 'Worlds':
        icon = '🌍';
        extra = <p style={{ margin: 0, fontWeight: '500', color: colors.textLight }}>Game ID: {item.game_id}</p>;
        break;
      case 'Enemies':
        icon = '👹';
        extra = (
          <>
            <p style={{ margin: 0, fontWeight: '500' }}>{item.type}</p>
            <p style={{ marginTop: '4px', fontSize: '0.9rem', color: colors.textLight }}>
              Game ID: {item.game_id}
            </p>
          </>
        );
        break;
      default:
        break;
    }

    return (
      <div
        key={item.id}
        style={{
          backgroundColor: colors.background,
          padding: '1rem',
          borderRadius: '12px',
          border: `1px solid ${colors.primary}20`,
          boxShadow: '0 8px 18px rgba(0,0,0,0.08)',
          cursor: 'pointer',
          transition: 'transform 0.2s, box-shadow 0.2s',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-4px)';
          e.currentTarget.style.boxShadow = '0 12px 25px rgba(0,0,0,0.15)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 8px 18px rgba(0,0,0,0.08)';
        }}
      >
        <h4 style={{ margin: '0 0 6px 0', color: colors.primary }}>
          {icon} {item.name || item.title || item.type}
        </h4>
        {extra}
      </div>
    );
  };

  const renderSection = (title, items, link, type) => (
    <div style={{ flex: '1 1 250px', minWidth: '220px' }}>
      <h3 style={{ color: colors.primary, marginBottom: '0.5rem' }}>{title}</h3>
      {items.length === 0 ? <p>No {title.toLowerCase()} found.</p> : <div style={{ display: 'grid', gap: '0.75rem' }}>{items.map((i) => renderCard(i, type))}</div>}
      <Link
        to={link}
        style={{
          display: 'inline-block',
          marginTop: '0.5rem',
          padding: '0.5rem 1rem',
          backgroundColor: colors.button,
          color: '#fff',
          borderRadius: '8px',
          textDecoration: 'none',
          transition: 'background-color 0.2s, transform 0.2s',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = colors.buttonHover;
          e.currentTarget.style.transform = 'translateY(-2px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = colors.button;
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      >
        View All
      </Link>
    </div>
  );

  return (
    <div style={{ maxWidth: '1000px', margin: '2rem auto', padding: '2rem' }}>
      <h1 style={{ color: colors.primary, marginBottom: '1rem', textAlign: 'center' }}>
        Mario Database – Learn SQL with Real Projects
      </h1>
      <p style={{ color: colors.text, lineHeight: '1.6', marginBottom: '2rem', textAlign: 'center' }}>
        Welkom! Leer SQL door echte projecten te maken. Begin met de lessen en oefen met echte data.
      </p>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1.5rem' }}>
        {renderSection('Characters', characters, '/characters', 'Characters')}
        {renderSection('Games', games, '/games', 'Games')}
        {renderSection('Worlds', worlds, '/worlds', 'Worlds')}
        {renderSection('Enemies', enemies, '/enemies', 'Enemies')}
      </div>

      <div style={{ textAlign: 'center', marginTop: '3rem' }}>
        <Link
          to="/lessons"
          style={{
            display: 'inline-block',
            padding: '0.75rem 1.5rem',
            backgroundColor: colors.button,
            color: '#fff',
            borderRadius: '8px',
            fontWeight: '500',
            textDecoration: 'none',
            transition: 'background-color 0.2s, transform 0.2s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = colors.buttonHover;
            e.currentTarget.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = colors.button;
            e.currentTarget.style.transform = 'translateY(0)';
          }}
        >
          Begin Lesson 1
        </Link>
      </div>
    </div>
  );
};

export default Home;